module.exports = __webpack_public_path__ + "img/jiomart.f97f2479.svg";